import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import ReviewCardGrid from "../../components/ReviewCard";

export default function Contact(props) {
    const theme = props.theme;

    return (
        <div className="contact-main">
            <Header theme={theme} setTheme={props.setTheme} />
            <h2 style={{textAlign: "center"}}>Reviews / Recommendations</h2>
            <hr />
            <div style={{ padding: '20px' }}>
                <ReviewCardGrid/>
            </div>
            <Footer theme={props.theme} onToggle={props.onToggle} />
        </div>
    );
}
